"use strict";
import darkStyles from "./src/theme-darkest.css.js";
import { Theme } from "./src/Theme.dev.js";
import "./core.dev.js";
Theme.registerThemeFragment("darkest", "color", darkStyles);
//# sourceMappingURL=theme-darkest.dev.js.map
